import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const LoadingSpinner = () => {
    const containerVariants = {
        start: {
            transition: {
                staggerChildren: 0.2
            }
        },
        end: {
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const circleVariants = {
        start: {
            y: "0%"
        },
        end: {
            y: "100%"
        }
    };

    const circleTransition = {
        duration: 0.5,
        yoyo: Infinity,
        ease: "easeInOut"
    };

    return (
        <LoadingContainer>
            <motion.div
                className="loading-container"
                variants={containerVariants}
                initial="start"
                animate="end"
            >
                <motion.div
                    className="loading-circle"
                    variants={circleVariants}
                    transition={circleTransition}
                />
                <motion.div
                    className="loading-circle"
                    variants={circleVariants}
                    transition={circleTransition}
                />
                <motion.div
                    className="loading-circle"
                    variants={circleVariants}
                    transition={circleTransition}
                />
            </motion.div>
            <motion.h2
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.5 }}
            >
                Loading Portfolio...
            </motion.h2>
        </LoadingContainer>
    );
};

const LoadingContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .loading-container {
        display: flex;
        justify-content: space-around;
        width: 80px;
        height: 40px;
        margin-bottom: 20px;
    }

    .loading-circle {
        width: 15px;
        height: 15px;
        background-color: #01a479;
        border-radius: 50%;
    }

    h2 {
        color: #343a40;
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0;
    }
`;

export default LoadingSpinner;